/* eslint-disable no-dupe-keys */
export default {
  gift_card_definition: {
    name: '礼品卡模板',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '礼品卡名称',
      coupon: '兑换礼品',
      cards_count: '卡数量',
      max_limit_cards_count: '最大卡数量',
      card_type: '礼品类型',
      redeemed_count: '已兑换数',
      redeem_valid_time: '兑换时间',
      redeem_begin_time: '领取礼品卡起始时间',
      redeem_end_time: '领取礼品卡截止时间',
      each_redeem_limit_count: '每人兑换上限',
      no_limit: '无限制',
      status: '状态',
      service_provider_id: '运营商',
      redeemed_coupon: '兑换的优惠券',
      redeemed_charging_card: '兑换的充电卡',
      redemption_qrcode_type: '兑换二维码类型',
      redemption_qrcode: '兑换二维码',
      third_party_product_number: '第三方渠道套餐码',
      created_at: '创建时间',
      updated_at: '更新时间',
      cards_count_remaining: '剩余{0}张'
    },
    // Enum的属性
    statuses: {
      expired: '已过期',
      enabled: '可用的',
      disabled: '停用的',
      active: '生效中',
      pending: '待启用'
    },
    filter_statuses: {
      expired: '已过期',
      disabled: '停用的',
      active: '生效中',
      pending: '待启用'
    },
    redemption_qrcode_type: {
      single_code: '一码多卡',
      multi_code: '一码一卡'
    },
    card_type: {
      coupon_definition: '优惠券',
      charging_card_definition: '充电卡'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询礼品卡名',
      input_gift_card_name: '请输入礼品卡名',
      input_third_party_product_number: '请输入第三方渠道（美团、淘宝、其他商城、抖音）的套餐码'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      charging_cards: '发放的充电卡',
      coupons: '发放的优惠券',
      redemption_records: '礼品卡'
    },
    detail_page: {
      status: {
        redeemed: '已兑换数',
        unredeemed: '未兑换数'
      }
    },
    // 标题
    titles: {
      base_info: '基本信息',
      convert_condition: '兑换条件',
      coupon_definition: '内含优惠券',
      charging_card_definition: '内含充电卡',
      redemption_qrcode: '兑换二维码',
      gift_card_redeemming_rate: '礼品卡兑换比例',
      gift_card_redeemming_count_days: '最后30天礼品卡兑换数',
      coupon_using_rate: '优惠券使用比例',
      coupon_day_using_count: '每日使用数'
    },
    btns: {
      select_coupon: '点击选择优惠券',
      select_charging_card: '点击选择充电卡',
      create_gift_card: '生成礼品卡'
    },
    qrcode_dialog: {
      title: '兑换二维码'
    },
    create_gift_card: {
      title: '手动生成礼品卡'
    },
    list_tabs: {
      all: '全部',
      expired: '已过期',
      disabled: '已停用',
      active: '生效中',
      pending: '待启用'
    }
  }
}
